import BaffleButton from '@nordinvestments/nord-storybook/dist/components/BaffleButton'
import ScrollTransition from '@nordinvestments/nord-storybook/dist/components/ScrollTransition'
import classNames from 'classnames'
import React from 'react'
import Col from 'react-bootstrap/Col'
import Row from 'react-bootstrap/Row'

import BaseSection from '../../../BaseSection'
import HeroShapesVideo from '../../../HeroShapesVideo'
import OnboardingLink from '../../../OnboardingLink'

import mp4Video from './media/responsible-investment.mp4'
import posterSrc from './media/responsible-investment.png'
import webmVideo from './media/responsible-investment.webm'
import styles from './ResponsibleInvestmentHero.module.scss'

const ResponsibleInvestmentHero = () => (
  <BaseSection.Hero
    backgroundClass={classNames(
      'bg-nord-gradient',
      styles.responsibleInvestmentHero
    )}
    withCut
  >
    <Row>
      <Col
        xs={12}
        lg={5}
        className="offset-lg-1 mt-4 mt-lg-0 my-lg-auto text-center text-lg-left"
      >
        <BaseSection.Header.HeroTop className="text-white" scrollReveal>
          Ansvarlig investering
        </BaseSection.Header.HeroTop>
        <BaseSection.Header.Base
          className="text-white"
          scrollReveal
          isHeroHeader
        >
          Investering i en bedre verden
        </BaseSection.Header.Base>
        <BaseSection.Text scrollReveal>
          Investér med dine værdier i behold. Få en portefølje, der tager hensyn
          til klima, mennesker og resten af verden.
        </BaseSection.Text>
        <ScrollTransition.Item>
          <OnboardingLink component={BaffleButton} variant="success">
            Læg en investeringsplan
          </OnboardingLink>
        </ScrollTransition.Item>
      </Col>
      <Col xs={12} lg={5} className="mt-5 mt-lg-0">
        <HeroShapesVideo
          variant="C"
          mp4Video={mp4Video}
          posterSrc={posterSrc}
          webmVideo={webmVideo}
        />
      </Col>
    </Row>
  </BaseSection.Hero>
)

export default ResponsibleInvestmentHero
